import { some } from 'lodash';

export const hasCampaignCreatives = campaigns =>
    some(campaigns, ({ campaignItemType }) => campaignItemType === 'HAS_REGULAR_ITEMS' || campaignItemType === null);
